import mirrorCreator from 'mirror-creator';
export { ActionTypes } from './actionTypes.js';
export { MENUS, MENU_SLUG, PERMITTED_WHITELIST } from './menu.js';
var AlertMessageTypes = mirrorCreator(['danger', 'success', 'warning']);
var DROPDOWN_SEARCH_MINIMUM = 7;
var TYPE_TEXT = 'text';
export { AlertMessageTypes, DROPDOWN_SEARCH_MINIMUM, TYPE_TEXT };